export function reckonDate () {
    let date = new Date()
    let weekDay = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    let dateList = [
        {
            ListYears: String(date.getFullYear()),
            ListMonths:
                date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1,
            ListDays:
                date.getDate() < 10 ? '0' + date.getDate() : String(date.getDate()),
            ListWeeks: String(weekDay[date.getDay()]),
            dateStr: String(date.getFullYear()) + (date.getMonth() + 1 < 10
                ? '0' + (date.getMonth() + 1)
                : date.getMonth() + 1) + (date.getDate() < 10 ? '0' + date.getDate() : String(date.getDate()))
        },
    ]
    for (let i = 1; i <= 6; i++) {
        date.setDate(date.getDate() + 1)
        dateList.push({
            ListYears: String(date.getFullYear()),
            ListMonths: date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1),
            ListDays: date.getDate() < 10 ? '0' + date.getDate() : String(date.getDate()),
            ListWeeks: String(weekDay[date.getDay()]),
            dateStr: String(date.getFullYear()) + (date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + (date.getDate() < 10 ? '0' + date.getDate() : String(date.getDate()))
        })
    }
    return dateList
}

// 更改时间格式  datecode = 20210101
export function _date_ (datecode) {
    let datecodeStr = String(datecode)
    if (datecodeStr.length == 8) {
        return datecodeStr.slice(0, 4) + '-' + datecodeStr.slice(4, 6) + '-' + datecodeStr.slice(6, 8)
    } else {
        return datecode
    }
}

// 计算平年闰年
function february (year) {
    if ((year % 100 != 0 && year % 4 == 0) || year % 400 == 0) {
        return 29
    } else {
        return 28
    }
}